<template>
  <div class="mobile-layout">
    <!-- 头部标题区域 -->
    <header class="screen-header">
      <div class="header-content">
        <div class="logo-section">
          <img src="@/assets/logo.png" alt="湖南新华" class="logo" />
          <h1 class="title">湖南新华数据大屏</h1>
        </div>
        <div class="time-section">
          <div class="current-time">{{ currentTime }}</div>
        </div>
      </div>
    </header>

    <!-- 临时提示：条件为 true 时显示 -->
    <div v-if="showBrowserHint" class="browser-hint">请在电脑浏览器端打开页面</div>

    <!-- 主要内容区域 - 移动端单栏垂直布局 -->
    <main class="screen-main">
      <div class="modules-container">
        <!-- 今日销售 -->
        <div class="module-container priority">
          <TodaySales />
        </div>

        <!-- 湖南地图 -->
        <div class="module-container map-container">
          <HunanMap />
        </div>

        <!-- 双栏模块组 -->
        <div class="module-row">
          <div class="module-container half">
            <BookStatistics />
          </div>
          <div class="module-container half">
            <TextbookStatistics />
          </div>
        </div>

        <!-- 会员趋势 -->
        <div class="module-container">
          <MemberTrend />
        </div>

        <!-- 双栏模块组 -->
        <div class="module-row">
          <div class="module-container half">
            <ChannelSales />
          </div>
          <div class="module-container half">
            <OrderComparison />
          </div>
        </div>

        <!-- 双栏模块组 -->
        <div class="module-row">
          <div class="module-container half">
            <SalesCategory />
          </div>
          <div class="module-container half">
            <CityChannelComparison />
          </div>
        </div>
      </div>
    </main>

    <!-- 加载遮罩 -->
    <div v-if="loading" class="loading-overlay">
      <div class="loading-spinner">
        <div class="spinner"></div>
        <div class="loading-text">数据加载中...</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import BookStatistics from '@/components/Modules/BookStatistics.vue'
import ChannelSales from '@/components/Modules/ChannelSales.vue'
import SalesCategory from '@/components/Modules/SalesCategory.vue'
import TodaySales from '@/components/Modules/TodaySales.vue'
import HunanMap from '@/components/Modules/HunanMap.vue'
import MemberTrend from '@/components/Modules/MemberTrend.vue'
import TextbookStatistics from '@/components/Modules/TextbookStatistics.vue'
import OrderComparison from '@/components/Modules/OrderComparison.vue'
import CityChannelComparison from '@/components/Modules/CityChannelComparison.vue'

export default {
  name: 'MobileLayout',
  components: {
    BookStatistics,
    ChannelSales,
    SalesCategory,
    TodaySales,
    HunanMap,
    MemberTrend,
    TextbookStatistics,
    OrderComparison,
    CityChannelComparison
  },
  props: {
    currentTime: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      showBrowserHint: true
    }
  },
  computed: {
    ...mapState(['loading', 'lastUpdateTime'])
  },
  mounted() {
  },
  methods: {
  }
}
</script>

<style lang="scss" scoped>
.mobile-layout {
  width: 100vw;
  min-height: 100vh;
  background: linear-gradient(135deg, #0c1426 0%, #1a2332 50%, #0c1426 100%);
  color: #ffffff;
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  position: relative;

  .browser-hint {
    position: fixed;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    z-index: 1000000;
    background: #fff;
    color: #ff9a57;
    font-size: 16px;
    padding: 6px 10px;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  // 头部样式
  .screen-header {
    height: 60px;
    background: linear-gradient(90deg, rgba(24, 144, 255, 0.1) 0%, rgba(24, 144, 255, 0.05) 100%);
    border-bottom: 2px solid rgba(24, 144, 255, 0.3);
    display: flex;
    align-items: center;
    padding: 0 20px;
    flex-shrink: 0;
    position: sticky;
    top: 0;
    z-index: 100;

    .header-content {
      width: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .logo-section {
        display: flex;
        align-items: center;
        gap: 10px;

        .logo {
          width: 30px;
          height: 30px;
          object-fit: contain;
        }

        .title {
          font-size: 18px;
          font-weight: bold;
          background: linear-gradient(45deg, #1890ff, #52c41a);
          -webkit-background-clip: text;
          -webkit-text-fill-color: transparent;
          margin: 0;
          text-shadow: 0 0 20px rgba(24, 144, 255, 0.5);
          white-space: nowrap;
        }
      }

      .time-section {
        text-align: right;

        .current-time {
          font-size: 16px;
          font-weight: bold;
          color: #1890ff;
          text-shadow: 0 0 10px rgba(24, 144, 255, 0.5);
        }
      }
    }
  }

  // 主要内容区域 - 移动端单栏垂直布局
  .screen-main {
    padding: 15px;

    .modules-container {
      display: flex;
      flex-direction: column;
      gap: 15px;
    }

    .module-container {
      background: linear-gradient(135deg, rgba(24, 144, 255, 0.1) 0%, rgba(24, 144, 255, 0.05) 100%);
      border: 1px solid rgba(24, 144, 255, 0.3);
      border-radius: 6px;
      padding: 15px;
      backdrop-filter: blur(10px);
      box-shadow: 0 4px 20px rgba(0, 0, 0, 0.3);
      min-height: 120px;
      overflow: hidden;

      &.priority {
        min-height: 100px;
        background: linear-gradient(135deg, rgba(24, 144, 255, 0.15) 0%, rgba(24, 144, 255, 0.08) 100%);
        border: 2px solid rgba(24, 144, 255, 0.4);
      }

      &.map-container {
        min-height: 250px;
      }

      &.half {
        flex: 1;
        min-height: 100px;
      }
    }

    .module-row {
      display: flex;
      gap: 15px;

      .module-container {
        margin: 0;
      }
    }
  }

  // 加载遮罩样式
  .loading-overlay {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.7);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;

    .loading-spinner {
      text-align: center;

      .spinner {
        width: 35px;
        height: 35px;
        border: 3px solid rgba(24, 144, 255, 0.3);
        border-top: 3px solid #1890ff;
        border-radius: 50%;
        animation: spin 1s linear infinite;
        margin: 0 auto 15px;
      }

      .loading-text {
        color: #1890ff;
        font-size: 14px;
        font-weight: bold;
      }
    }
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }

  // 小屏幕优化
  @media screen and (max-width: 400px) {
    .screen-header {
      height: 55px;
      padding: 0 15px;

      .header-content {
        .logo-section {
          gap: 8px;

          .logo {
            width: 25px;
            height: 25px;
          }

          .title {
            font-size: 16px;
          }
        }

        .time-section {
          .current-time {
            font-size: 14px;
          }
        }
      }
    }

    .screen-main {
      padding: 10px;

      .modules-container {
        gap: 10px;
      }

      .module-container {
        padding: 12px;
        min-height: 100px;

        &.map-container {
          min-height: 200px;
        }

        &.half {
          min-height: 80px;
        }
      }

      .module-row {
        gap: 10px;
      }
    }
  }

  // 横屏适配
  @media screen and (orientation: landscape) and (max-height: 500px) {
    .screen-header {
      height: 50px;
    }

    .screen-main {
      .module-container {
        min-height: 80px;

        &.map-container {
          min-height: 150px;
        }

        &.half {
          min-height: 70px;
        }
      }
    }
  }
}
</style>